const API_URL = 'admin'

export const state = () => ({
  devices: { items: [] },
  users: [],
})

export const getters = {}

export const mutations = {
  SET_DEVICES(state, waste_company_devices) {
    state.devices = waste_company_devices
  },
  PUSH_OR_REPLACE_DEVICE(state, new_device) {
    let device_index = state.devices.items.findIndex(device => device.id === parseInt(new_device.id))

    if (device_index >= 0) {
      state.devices.items.splice(device_index, 1, new_device)
    } else {
      state.devices.items.push(new_device)
    }
  },
  SET_USERS(state, users) {
    state.users = users
  },
}

export const actions = {
  async fetchAllDevices({ commit }, params = null) {
    let { data: devices } = await useApi(`${API_URL}/device`, {
      query: params,
    })

    commit('SET_DEVICES', devices.value)

    return devices.value
  },
  async exportAllDevices({ commit }, { params }) {
    let config = { query: params, responseType: 'blob' }
    let { data } = await useApi(`${API_URL}/device/export`, config)
    return data.value
  },
  async storeDevice({ commit }, device) {
    let { data } = await useApi(`${API_URL}/device`, { method: 'post', body: device })
    device = data.value
    commit('PUSH_OR_REPLACE_DEVICE', device)

    return device
  },
  async fetchAllUsers({ commit }, params = null) {
    let { data: users } = await useApi(`${API_URL}/user`, {
      query: params,
    })
    commit('SET_USERS', users.value)

    return users.value
  },
}
